export enum ReservationJobActions {
  InProgresByJob = '-1',
  FinalizedByJob = '-2',
  CancelledByJob = '-3',
  CancelledByContinuousReservation = '-5',
}
